// extracted by mini-css-extract-plugin
module.exports = {"Header":"Navigation_Header__3lLux","Navigation":"Navigation_Navigation__1H0UZ","DesktopOnly":"Navigation_DesktopOnly__10M1F"};